import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { HttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuardGuard implements CanActivate {
  constructor(private httpService: HttpService, private router: Router) {}

  canActivate(): boolean {
    const role = this.httpService.user.getValue()?.role;
    if (role === 'ADMIN') {
      return true;
    }
    this.router.navigate(['/dashboard']);
    return false;
  }
}
